var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "invite-rules-root",
      class: { "ar-style": _vm.$i18n.locale === "ar" },
    },
    [
      _c(
        "div",
        {
          staticClass: "custom-nav-block",
          style: `paddingTop:${_vm.barHeight}px`,
        },
        [
          _c("van-nav-bar", {
            attrs: { title: "", "left-arrow": "" },
            on: { "click-left": _vm.goPrevious },
            scopedSlots: _vm._u([
              {
                key: "left",
                fn: function () {
                  return [
                    _c("img", {
                      staticClass: "left-nav",
                      attrs: {
                        src: require("@/assets/packageAssets/common/arrow01.png"),
                        alt: "",
                      },
                    }),
                    _c("span", { staticClass: "tit-left" }, [
                      _vm._v(_vm._s(_vm.$t("lang.call.tit1"))),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _c("div", { staticClass: "rules-content" }, [
        _c(
          "div",
          {
            staticClass: "rules-block",
            staticStyle: { "letter-spacing": "-0.5px" },
          },
          [
            _c("p", { staticClass: "rules-title right-read" }, [
              _vm._v(_vm._s(_vm.$t("lang.commonM.k458"))),
            ]),
            _c("p", { staticClass: "rules-row right-read" }, [
              _vm._v("1. " + _vm._s(_vm.$t("lang.commonM.k459"))),
            ]),
            _c("MyPLabel", {
              staticClass: "rules-row right-read",
              attrs: {
                str: `2. ${_vm.$t("lang.commonM.k460")}`,
                numsOption: [{ value: _vm.time }],
              },
            }),
            _c("MyPLabel", {
              staticClass: "rules-row right-read",
              attrs: {
                str: `3. ${_vm.$t("lang.commonM.k463")}`,
                numsOption: [{ value: _vm.time }],
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "rules-block",
            staticStyle: { "letter-spacing": "-0.5px" },
          },
          [
            _c("p", { staticClass: "rules-title right-read" }, [
              _vm._v(_vm._s(_vm.$t("lang.commonM.k461"))),
            ]),
            _c("p", { staticClass: "rules-row right-read" }, [
              _vm._v("1. " + _vm._s(_vm.$t("lang.commonM.k462"))),
            ]),
            _c("MyPLabel", {
              staticClass: "rules-row right-read",
              attrs: {
                str: `2. ${_vm.$t("lang.commonM.k460")}`,
                numsOption: [{ value: _vm.time }],
              },
            }),
            _c("MyPLabel", {
              staticClass: "rules-row right-read",
              attrs: {
                str: `3. ${_vm.$t("lang.commonM.k463")}`,
                numsOption: [{ value: _vm.time }],
              },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }